import { useState } from "react";
import PropTypes from "prop-types";

import Icon from "components/ShellV2/Icon";

/* Sticky anchor sidenav for settings-style pages. Each item scrolls to the
   element with id `${item.id}-info`. */
export default function AnchorNav({ items, offset }) {
  const [active, setActive] = useState(items[0]?.id);

  const scrollTo = (id) => {
    setActive(id);
    const el = document.getElementById(`${id}-info`);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    }
  };

  return (
    <nav className="rec-anchor-nav">
      {items.map((it) => (
        <a
          key={it.id}
          href={`#${it.id}-info`}
          className={active === it.id ? "on" : ""}
          onClick={(e) => {
            e.preventDefault();
            scrollTo(it.id);
          }}
        >
          <Icon name={it.icon} />
          {it.label}
        </a>
      ))}
    </nav>
  );
}

AnchorNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    })
  ).isRequired,
  offset: PropTypes.number,
};

AnchorNav.defaultProps = {
  offset: 88,
};
